import ReactDOM from 'react-dom/client'
import './styles.css'
import App from './App'
import { BrowserRouter, Route, Routes } from 'react-router'
import Metro from './components/Metro'
import GlobalStyles from './components/GlobalStyles'

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/metro" element={<Metro />} />
    </Routes>
    <GlobalStyles />
  </BrowserRouter>
)
